module.exports = __webpack_public_path__ + "img/meme_25.47efa5ca.jpg";